import React from 'react';

import styled from '@emotion/styled';

import useSetSettings from '../../../../hooks/dashboard/settings/useSetSettings';
import {
  ContactsToggleInitialValues,
  ContactsToggleSchema,
} from '../../../../models/dashboard/settings/contacts-toggle';
import { useAppSelector } from '../../../../redux/store';
import { FormComponent } from '../../../FormCom/FormComponent';
import ToggleButtonField from '../../../FormCom/ToggleButtonField';

const SaveToContact = () => {
  const { settingsData } = useAppSelector((state) => state.settingsData);
  const { setSetting } = useSetSettings();

  ContactsToggleInitialValues.autosave = settingsData?.autosave ? true : false;
  return (
    <Container>
      <Top>
        <BoldText>Autosave contacts</BoldText>
        <div>
          <FormComponent
            initialValues={ContactsToggleInitialValues}
            schema={ContactsToggleSchema}
            onSubmit={() => void 0}
          >
            <ToggleButtonField
              name='autosave'
              onChange={(checked) =>
                setSetting({ autosave: checked }, () => void 0)
              }
            />
          </FormComponent>
        </div>
      </Top>
      <Bottom>Search saved contacts or enter an email </Bottom>
    </Container>
  );
};

export default SaveToContact;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: rgba(91, 145, 245, 0.05);
  gap: 4px;
  padding: 10px;
  border-radius: 8px;
`;

const Top = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const BoldText = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 14px;
  color: ${({ theme }) => theme.palette.neutralGray};
`;

const Bottom = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
`;
